/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  AppendToRegistries200Response,
  AppendToRegistries400Response,
  AppendToRegistries422Response,
  BulkAppendOtherRegistries400Response,
  ExportList400Response,
  GetAddressSuggest401Response,
  GetAddressSuggest403Response,
  GetCommonState400Response,
  GetList200Response,
  GetOtherRegistries200Response,
  GetOwnerList200Response,
  GetRegistry200Response,
  GetRegistry404Response,
  GetRegistryPrivileges200Response,
  GetRegistryPrivileges404Response,
  GetTabsCount200Response,
  RegistryExportParams,
  RegistryType,
  RemoveFromRegistries400Response,
  SearchInstructions422Response,
} from '../models/index'
import {
  AppendToRegistries200ResponseFromJSON,
  AppendToRegistries200ResponseToJSON,
  AppendToRegistries400ResponseFromJSON,
  AppendToRegistries400ResponseToJSON,
  AppendToRegistries422ResponseFromJSON,
  AppendToRegistries422ResponseToJSON,
  BulkAppendOtherRegistries400ResponseFromJSON,
  BulkAppendOtherRegistries400ResponseToJSON,
  ExportList400ResponseFromJSON,
  ExportList400ResponseToJSON,
  GetAddressSuggest401ResponseFromJSON,
  GetAddressSuggest401ResponseToJSON,
  GetAddressSuggest403ResponseFromJSON,
  GetAddressSuggest403ResponseToJSON,
  GetCommonState400ResponseFromJSON,
  GetCommonState400ResponseToJSON,
  GetList200ResponseFromJSON,
  GetList200ResponseToJSON,
  GetOtherRegistries200ResponseFromJSON,
  GetOtherRegistries200ResponseToJSON,
  GetOwnerList200ResponseFromJSON,
  GetOwnerList200ResponseToJSON,
  GetRegistry200ResponseFromJSON,
  GetRegistry200ResponseToJSON,
  GetRegistry404ResponseFromJSON,
  GetRegistry404ResponseToJSON,
  GetRegistryPrivileges200ResponseFromJSON,
  GetRegistryPrivileges200ResponseToJSON,
  GetRegistryPrivileges404ResponseFromJSON,
  GetRegistryPrivileges404ResponseToJSON,
  GetTabsCount200ResponseFromJSON,
  GetTabsCount200ResponseToJSON,
  RegistryExportParamsFromJSON,
  RegistryExportParamsToJSON,
  RegistryTypeFromJSON,
  RegistryTypeToJSON,
  RemoveFromRegistries400ResponseFromJSON,
  RemoveFromRegistries400ResponseToJSON,
  SearchInstructions422ResponseFromJSON,
  SearchInstructions422ResponseToJSON,
} from '../models/index'

export interface AppendToRegistriesRequest {
  path: string
}

export interface BulkAppendOtherRegistriesRequest {
  registryId: string
}

export interface ExportListRequest {
  search?: string
  mktu?: Array<number>
  owners?: Array<string>
  exportParams?: RegistryExportParams
  dateFilter?: string
}

export interface GetListRequest {
  registryType: RegistryType
  search?: string
  mktu?: Array<number>
  owners?: Array<string>
  dateFilter?: string
  page?: number
  perPage?: number
}

export interface GetOtherRegistriesRequest {
  registryId: string
}

export interface GetRegistryRequest {
  registryId: string
}

export interface GetRegistryFallbackImageRequest {
  path: string
}

export interface GetRegistryPrivilegesRequest {
  registryId: string
}

export interface GetTabsCountRequest {
  search?: string
  mktu?: Array<number>
  owners?: Array<string>
}

export interface RemoveFromRegistriesRequest {
  path: string
}

/**
 * RegistriesApi - interface
 *
 * @export
 * @interface RegistriesApiInterface
 */
export interface RegistriesApiInterface {
  /**
   * Добавление регистра (свидетельства ТЗ) в пользовательские регистры текущего пользователя по пути. Заявки добавлять нельзя; уже добавленный регистр повторно не добавляется. Требуется подтверждённый email.
   * @summary Добавить регистр в портфель
   * @param {string} path Путь реестра: &lt;scope&gt;-&lt;база&gt;&lt;номер&gt;
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegistriesApiInterface
   */
  appendToRegistriesRaw(
    requestParameters: AppendToRegistriesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AppendToRegistries200Response>>

  /**
   * Добавление регистра (свидетельства ТЗ) в пользовательские регистры текущего пользователя по пути. Заявки добавлять нельзя; уже добавленный регистр повторно не добавляется. Требуется подтверждённый email.
   * Добавить регистр в портфель
   */
  appendToRegistries(
    requestParameters: AppendToRegistriesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AppendToRegistries200Response>

  /**
   * Массовое добавление в портфель текущего пользователя всех «других ТЗ правообладателя» по указанному регистру (свидетельства баз RUTM, уже добавленные пропускаются). Пользователю с ролью SEE_ALL_APPLICATIONS (кабинет info) действие запрещено. Требуется подтверждённый email.
   * @summary Массово добавить другие ТЗ правообладателя
   * @param {string} registryId Путь реестра: &lt;scope&gt;-&lt;база&gt;&lt;номер&gt;
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegistriesApiInterface
   */
  bulkAppendOtherRegistriesRaw(
    requestParameters: BulkAppendOtherRegistriesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AppendToRegistries200Response>>

  /**
   * Массовое добавление в портфель текущего пользователя всех «других ТЗ правообладателя» по указанному регистру (свидетельства баз RUTM, уже добавленные пропускаются). Пользователю с ролью SEE_ALL_APPLICATIONS (кабинет info) действие запрещено. Требуется подтверждённый email.
   * Массово добавить другие ТЗ правообладателя
   */
  bulkAppendOtherRegistries(
    requestParameters: BulkAppendOtherRegistriesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AppendToRegistries200Response>

  /**
   * Экспорт списка пользовательских регистров текущего пользователя в xlsx (сортировка как в списке). exportParams — карта колонок выгрузки (ключ — колонка, значение — включить ли её): number, registrationDate, registrationOfficeCode, expiryDate, applicationNumber, tradeMarkName, image, imageUrl, rightholder, mktuList, status. dateFilter на выгрузку не влияет. Требуется подтверждённый email.
   * @summary Экспорт списка регистров в xlsx
   * @param {string} [search] Поисковая строка (по полям реестра)
   * @param {Array<number>} [mktu] Классы МКТУ (1–45)
   * @param {Array<string>} [owners] Правообладатели
   * @param {RegistryExportParams} [exportParams] Карта колонок выгрузки: ключ — имя колонки, значение — включить в файл
   * @param {string} [dateFilter] Фильтр по сроку действия (не влияет на выгрузку, принимается для единообразия со списком)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegistriesApiInterface
   */
  exportListRaw(
    requestParameters: ExportListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>>

  /**
   * Экспорт списка пользовательских регистров текущего пользователя в xlsx (сортировка как в списке). exportParams — карта колонок выгрузки (ключ — колонка, значение — включить ли её): number, registrationDate, registrationOfficeCode, expiryDate, applicationNumber, tradeMarkName, image, imageUrl, rightholder, mktuList, status. dateFilter на выгрузку не влияет. Требуется подтверждённый email.
   * Экспорт списка регистров в xlsx
   */
  exportList(
    requestParameters: ExportListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob>

  /**
   * Список пользовательских регистров (портфель) текущего пользователя по секции. Сортировка: сначала регистры с датой истечения в интервале −6 месяцев…+1 год (по возрастанию даты), остальные — по дате добавления (убывание). Требуется подтверждённый email.
   * @summary Получить список пользовательских регистров
   * @param {RegistryType} registryType Секция реестра
   * @param {string} [search] Поисковая строка (по полям реестра)
   * @param {Array<number>} [mktu] Классы МКТУ (1–45)
   * @param {Array<string>} [owners] Правообладатели
   * @param {string} [dateFilter] Фильтр по сроку действия: ALL — все, VALID — больше года, EXPIRES — меньше года либо истёк не более 6 месяцев назад, EXPIRED — восстановление невозможно
   * @param {number} [page] Номер страницы
   * @param {number} [perPage] Записей на странице
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegistriesApiInterface
   */
  getListRaw(
    requestParameters: GetListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetList200Response>>

  /**
   * Список пользовательских регистров (портфель) текущего пользователя по секции. Сортировка: сначала регистры с датой истечения в интервале −6 месяцев…+1 год (по возрастанию даты), остальные — по дате добавления (убывание). Требуется подтверждённый email.
   * Получить список пользовательских регистров
   */
  getList(
    requestParameters: GetListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetList200Response>

  /**
   * Другие ТЗ и зТЗ того же номера: ipo — свидетельства (отсортированы по близости даты истечения действия), applications — заявки. notAppendedIpo — количество свидетельств, не добавленных в пользовательские регистры текущего пользователя. Если данных нет — data пустой массив. Требуется подтверждённый email.
   * @summary Получить другие ТЗ и зТЗ
   * @param {string} registryId Путь реестра: &lt;scope&gt;-&lt;база&gt;&lt;номер&gt;
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegistriesApiInterface
   */
  getOtherRegistriesRaw(
    requestParameters: GetOtherRegistriesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetOtherRegistries200Response>>

  /**
   * Другие ТЗ и зТЗ того же номера: ipo — свидетельства (отсортированы по близости даты истечения действия), applications — заявки. notAppendedIpo — количество свидетельств, не добавленных в пользовательские регистры текущего пользователя. Если данных нет — data пустой массив. Требуется подтверждённый email.
   * Получить другие ТЗ и зТЗ
   */
  getOtherRegistries(
    requestParameters: GetOtherRegistriesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetOtherRegistries200Response>

  /**
   * Список правообладателей свидетельств, добавленных в портфель текущего пользователя. Требуется подтверждённый email.
   * @summary Список владельцев свидетельств портфеля
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegistriesApiInterface
   */
  getOwnerListRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetOwnerList200Response>>

  /**
   * Список правообладателей свидетельств, добавленных в портфель текущего пользователя. Требуется подтверждённый email.
   * Список владельцев свидетельств портфеля
   */
  getOwnerList(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetOwnerList200Response>

  /**
   * Данные реестра по пути: свидетельство (ТЗ) либо заявка на товарный знак (зТЗ) — состав полей data зависит от типа записи (поля с пометкой «только ТЗ»/«только зТЗ» присутствуют у соответствующего типа). Результат кешируется на 3 часа. Требуется подтверждённый email.
   * @summary Получить данные о товарном знаке
   * @param {string} registryId Путь реестра: &lt;scope&gt;-&lt;база&gt;&lt;номер&gt;
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegistriesApiInterface
   */
  getRegistryRaw(
    requestParameters: GetRegistryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetRegistry200Response>>

  /**
   * Данные реестра по пути: свидетельство (ТЗ) либо заявка на товарный знак (зТЗ) — состав полей data зависит от типа записи (поля с пометкой «только ТЗ»/«только зТЗ» присутствуют у соответствующего типа). Результат кешируется на 3 часа. Требуется подтверждённый email.
   * Получить данные о товарном знаке
   */
  getRegistry(
    requestParameters: GetRegistryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetRegistry200Response>

  /**
   * Публичный эндпоинт (без авторизации): webp-изображение реестра из хранилища, отдаётся как скачивание (Content-Disposition: attachment). При отсутствии изображения в хранилище или неверном пути реестра возвращается пустой ответ 200 без тела.
   * @summary Fallback-изображение реестра
   * @param {string} path Путь реестра: &lt;scope&gt;-&lt;база&gt;&lt;номер&gt;
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegistriesApiInterface
   */
  getRegistryFallbackImageRaw(
    requestParameters: GetRegistryFallbackImageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>>

  /**
   * Публичный эндпоинт (без авторизации): webp-изображение реестра из хранилища, отдаётся как скачивание (Content-Disposition: attachment). При отсутствии изображения в хранилище или неверном пути реестра возвращается пустой ответ 200 без тела.
   * Fallback-изображение реестра
   */
  getRegistryFallbackImage(
    requestParameters: GetRegistryFallbackImageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob>

  /**
   * Права текущего пользователя на регистр. Для заявок (зТЗ) возвращается только userIsRegistryOwner, для свидетельств (ТЗ) — полный набор полей. Требуется подтверждённый email.
   * @summary Получить права пользователя на регистр
   * @param {string} registryId Путь реестра: &lt;scope&gt;-&lt;база&gt;&lt;номер&gt;
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegistriesApiInterface
   */
  getRegistryPrivilegesRaw(
    requestParameters: GetRegistryPrivilegesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetRegistryPrivileges200Response>>

  /**
   * Права текущего пользователя на регистр. Для заявок (зТЗ) возвращается только userIsRegistryOwner, для свидетельств (ТЗ) — полный набор полей. Требуется подтверждённый email.
   * Получить права пользователя на регистр
   */
  getRegistryPrivileges(
    requestParameters: GetRegistryPrivilegesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetRegistryPrivileges200Response>

  /**
   * Количество пользовательских регистров текущего пользователя по вкладкам фильтра срока действия: ALL — все, VALID — срок больше года, EXPIRES — меньше года либо истёк не более 6 месяцев назад, EXPIRED — восстановление невозможно. dateFilter на подсчёт не влияет. Требуется подтверждённый email.
   * @summary Счётчики вкладок списка регистров
   * @param {string} [search] Поисковая строка (по полям реестра)
   * @param {Array<number>} [mktu] Классы МКТУ (1–45)
   * @param {Array<string>} [owners] Правообладатели
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegistriesApiInterface
   */
  getTabsCountRaw(
    requestParameters: GetTabsCountRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetTabsCount200Response>>

  /**
   * Количество пользовательских регистров текущего пользователя по вкладкам фильтра срока действия: ALL — все, VALID — срок больше года, EXPIRES — меньше года либо истёк не более 6 месяцев назад, EXPIRED — восстановление невозможно. dateFilter на подсчёт не влияет. Требуется подтверждённый email.
   * Счётчики вкладок списка регистров
   */
  getTabsCount(
    requestParameters: GetTabsCountRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetTabsCount200Response>

  /**
   * Удаление регистра из пользовательских регистров текущего пользователя по пути. Удалять может только пользователь, добавивший регистр (не владелец портфеля info). Требуется подтверждённый email.
   * @summary Удалить регистр из портфеля
   * @param {string} path Путь реестра: &lt;scope&gt;-&lt;база&gt;&lt;номер&gt;
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegistriesApiInterface
   */
  removeFromRegistriesRaw(
    requestParameters: RemoveFromRegistriesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AppendToRegistries200Response>>

  /**
   * Удаление регистра из пользовательских регистров текущего пользователя по пути. Удалять может только пользователь, добавивший регистр (не владелец портфеля info). Требуется подтверждённый email.
   * Удалить регистр из портфеля
   */
  removeFromRegistries(
    requestParameters: RemoveFromRegistriesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AppendToRegistries200Response>
}

/**
 *
 */
export class RegistriesApi
  extends runtime.BaseAPI
  implements RegistriesApiInterface
{
  /**
   * Добавление регистра (свидетельства ТЗ) в пользовательские регистры текущего пользователя по пути. Заявки добавлять нельзя; уже добавленный регистр повторно не добавляется. Требуется подтверждённый email.
   * Добавить регистр в портфель
   */
  async appendToRegistriesRaw(
    requestParameters: AppendToRegistriesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AppendToRegistries200Response>> {
    if (requestParameters['path'] == null) {
      throw new runtime.RequiredError(
        'path',
        'Required parameter "path" was null or undefined when calling appendToRegistries().'
      )
    }

    const queryParameters: any = {}

    if (requestParameters['path'] != null) {
      queryParameters['path'] = requestParameters['path']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/user-registries/append-registry-to-user-registries`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AppendToRegistries200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Добавление регистра (свидетельства ТЗ) в пользовательские регистры текущего пользователя по пути. Заявки добавлять нельзя; уже добавленный регистр повторно не добавляется. Требуется подтверждённый email.
   * Добавить регистр в портфель
   */
  async appendToRegistries(
    requestParameters: AppendToRegistriesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AppendToRegistries200Response> {
    const response = await this.appendToRegistriesRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Массовое добавление в портфель текущего пользователя всех «других ТЗ правообладателя» по указанному регистру (свидетельства баз RUTM, уже добавленные пропускаются). Пользователю с ролью SEE_ALL_APPLICATIONS (кабинет info) действие запрещено. Требуется подтверждённый email.
   * Массово добавить другие ТЗ правообладателя
   */
  async bulkAppendOtherRegistriesRaw(
    requestParameters: BulkAppendOtherRegistriesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AppendToRegistries200Response>> {
    if (requestParameters['registryId'] == null) {
      throw new runtime.RequiredError(
        'registryId',
        'Required parameter "registryId" was null or undefined when calling bulkAppendOtherRegistries().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/user-registries/{registryId}/bulk-append-other-registries`.replace(
          `{${'registryId'}}`,
          encodeURIComponent(String(requestParameters['registryId']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AppendToRegistries200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Массовое добавление в портфель текущего пользователя всех «других ТЗ правообладателя» по указанному регистру (свидетельства баз RUTM, уже добавленные пропускаются). Пользователю с ролью SEE_ALL_APPLICATIONS (кабинет info) действие запрещено. Требуется подтверждённый email.
   * Массово добавить другие ТЗ правообладателя
   */
  async bulkAppendOtherRegistries(
    requestParameters: BulkAppendOtherRegistriesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AppendToRegistries200Response> {
    const response = await this.bulkAppendOtherRegistriesRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Экспорт списка пользовательских регистров текущего пользователя в xlsx (сортировка как в списке). exportParams — карта колонок выгрузки (ключ — колонка, значение — включить ли её): number, registrationDate, registrationOfficeCode, expiryDate, applicationNumber, tradeMarkName, image, imageUrl, rightholder, mktuList, status. dateFilter на выгрузку не влияет. Требуется подтверждённый email.
   * Экспорт списка регистров в xlsx
   */
  async exportListRaw(
    requestParameters: ExportListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>> {
    const queryParameters: any = {}

    if (requestParameters['search'] != null) {
      queryParameters['search'] = requestParameters['search']
    }

    if (requestParameters['mktu'] != null) {
      queryParameters['mktu'] = requestParameters['mktu']
    }

    if (requestParameters['owners'] != null) {
      queryParameters['owners'] = requestParameters['owners']
    }

    if (requestParameters['exportParams'] != null) {
      queryParameters['exportParams'] = requestParameters['exportParams']
    }

    if (requestParameters['dateFilter'] != null) {
      queryParameters['dateFilter'] = requestParameters['dateFilter']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/user-registries/export-list`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.BlobApiResponse(response)
  }

  /**
   * Экспорт списка пользовательских регистров текущего пользователя в xlsx (сортировка как в списке). exportParams — карта колонок выгрузки (ключ — колонка, значение — включить ли её): number, registrationDate, registrationOfficeCode, expiryDate, applicationNumber, tradeMarkName, image, imageUrl, rightholder, mktuList, status. dateFilter на выгрузку не влияет. Требуется подтверждённый email.
   * Экспорт списка регистров в xlsx
   */
  async exportList(
    requestParameters: ExportListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob> {
    const response = await this.exportListRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * Список пользовательских регистров (портфель) текущего пользователя по секции. Сортировка: сначала регистры с датой истечения в интервале −6 месяцев…+1 год (по возрастанию даты), остальные — по дате добавления (убывание). Требуется подтверждённый email.
   * Получить список пользовательских регистров
   */
  async getListRaw(
    requestParameters: GetListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetList200Response>> {
    if (requestParameters['registryType'] == null) {
      throw new runtime.RequiredError(
        'registryType',
        'Required parameter "registryType" was null or undefined when calling getList().'
      )
    }

    const queryParameters: any = {}

    if (requestParameters['search'] != null) {
      queryParameters['search'] = requestParameters['search']
    }

    if (requestParameters['mktu'] != null) {
      queryParameters['mktu'] = requestParameters['mktu']
    }

    if (requestParameters['owners'] != null) {
      queryParameters['owners'] = requestParameters['owners']
    }

    if (requestParameters['dateFilter'] != null) {
      queryParameters['dateFilter'] = requestParameters['dateFilter']
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page']
    }

    if (requestParameters['perPage'] != null) {
      queryParameters['perPage'] = requestParameters['perPage']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/user-registries/{registryType}`.replace(
          `{${'registryType'}}`,
          encodeURIComponent(String(requestParameters['registryType']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetList200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Список пользовательских регистров (портфель) текущего пользователя по секции. Сортировка: сначала регистры с датой истечения в интервале −6 месяцев…+1 год (по возрастанию даты), остальные — по дате добавления (убывание). Требуется подтверждённый email.
   * Получить список пользовательских регистров
   */
  async getList(
    requestParameters: GetListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetList200Response> {
    const response = await this.getListRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * Другие ТЗ и зТЗ того же номера: ipo — свидетельства (отсортированы по близости даты истечения действия), applications — заявки. notAppendedIpo — количество свидетельств, не добавленных в пользовательские регистры текущего пользователя. Если данных нет — data пустой массив. Требуется подтверждённый email.
   * Получить другие ТЗ и зТЗ
   */
  async getOtherRegistriesRaw(
    requestParameters: GetOtherRegistriesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetOtherRegistries200Response>> {
    if (requestParameters['registryId'] == null) {
      throw new runtime.RequiredError(
        'registryId',
        'Required parameter "registryId" was null or undefined when calling getOtherRegistries().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/registry/{registryId}/other-registries`.replace(
          `{${'registryId'}}`,
          encodeURIComponent(String(requestParameters['registryId']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetOtherRegistries200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Другие ТЗ и зТЗ того же номера: ipo — свидетельства (отсортированы по близости даты истечения действия), applications — заявки. notAppendedIpo — количество свидетельств, не добавленных в пользовательские регистры текущего пользователя. Если данных нет — data пустой массив. Требуется подтверждённый email.
   * Получить другие ТЗ и зТЗ
   */
  async getOtherRegistries(
    requestParameters: GetOtherRegistriesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetOtherRegistries200Response> {
    const response = await this.getOtherRegistriesRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Список правообладателей свидетельств, добавленных в портфель текущего пользователя. Требуется подтверждённый email.
   * Список владельцев свидетельств портфеля
   */
  async getOwnerListRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetOwnerList200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/user-registries/owners-list`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetOwnerList200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Список правообладателей свидетельств, добавленных в портфель текущего пользователя. Требуется подтверждённый email.
   * Список владельцев свидетельств портфеля
   */
  async getOwnerList(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetOwnerList200Response> {
    const response = await this.getOwnerListRaw(initOverrides)
    return await response.value()
  }

  /**
   * Данные реестра по пути: свидетельство (ТЗ) либо заявка на товарный знак (зТЗ) — состав полей data зависит от типа записи (поля с пометкой «только ТЗ»/«только зТЗ» присутствуют у соответствующего типа). Результат кешируется на 3 часа. Требуется подтверждённый email.
   * Получить данные о товарном знаке
   */
  async getRegistryRaw(
    requestParameters: GetRegistryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetRegistry200Response>> {
    if (requestParameters['registryId'] == null) {
      throw new runtime.RequiredError(
        'registryId',
        'Required parameter "registryId" was null or undefined when calling getRegistry().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/registry/{registryId}`.replace(
          `{${'registryId'}}`,
          encodeURIComponent(String(requestParameters['registryId']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetRegistry200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Данные реестра по пути: свидетельство (ТЗ) либо заявка на товарный знак (зТЗ) — состав полей data зависит от типа записи (поля с пометкой «только ТЗ»/«только зТЗ» присутствуют у соответствующего типа). Результат кешируется на 3 часа. Требуется подтверждённый email.
   * Получить данные о товарном знаке
   */
  async getRegistry(
    requestParameters: GetRegistryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetRegistry200Response> {
    const response = await this.getRegistryRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * Публичный эндпоинт (без авторизации): webp-изображение реестра из хранилища, отдаётся как скачивание (Content-Disposition: attachment). При отсутствии изображения в хранилище или неверном пути реестра возвращается пустой ответ 200 без тела.
   * Fallback-изображение реестра
   */
  async getRegistryFallbackImageRaw(
    requestParameters: GetRegistryFallbackImageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>> {
    if (requestParameters['path'] == null) {
      throw new runtime.RequiredError(
        'path',
        'Required parameter "path" was null or undefined when calling getRegistryFallbackImage().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/registry/fallback-image/{path}`.replace(
          `{${'path'}}`,
          encodeURIComponent(String(requestParameters['path']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.BlobApiResponse(response)
  }

  /**
   * Публичный эндпоинт (без авторизации): webp-изображение реестра из хранилища, отдаётся как скачивание (Content-Disposition: attachment). При отсутствии изображения в хранилище или неверном пути реестра возвращается пустой ответ 200 без тела.
   * Fallback-изображение реестра
   */
  async getRegistryFallbackImage(
    requestParameters: GetRegistryFallbackImageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob> {
    const response = await this.getRegistryFallbackImageRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Права текущего пользователя на регистр. Для заявок (зТЗ) возвращается только userIsRegistryOwner, для свидетельств (ТЗ) — полный набор полей. Требуется подтверждённый email.
   * Получить права пользователя на регистр
   */
  async getRegistryPrivilegesRaw(
    requestParameters: GetRegistryPrivilegesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetRegistryPrivileges200Response>> {
    if (requestParameters['registryId'] == null) {
      throw new runtime.RequiredError(
        'registryId',
        'Required parameter "registryId" was null or undefined when calling getRegistryPrivileges().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/registry/{registryId}/privileges`.replace(
          `{${'registryId'}}`,
          encodeURIComponent(String(requestParameters['registryId']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetRegistryPrivileges200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Права текущего пользователя на регистр. Для заявок (зТЗ) возвращается только userIsRegistryOwner, для свидетельств (ТЗ) — полный набор полей. Требуется подтверждённый email.
   * Получить права пользователя на регистр
   */
  async getRegistryPrivileges(
    requestParameters: GetRegistryPrivilegesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetRegistryPrivileges200Response> {
    const response = await this.getRegistryPrivilegesRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Количество пользовательских регистров текущего пользователя по вкладкам фильтра срока действия: ALL — все, VALID — срок больше года, EXPIRES — меньше года либо истёк не более 6 месяцев назад, EXPIRED — восстановление невозможно. dateFilter на подсчёт не влияет. Требуется подтверждённый email.
   * Счётчики вкладок списка регистров
   */
  async getTabsCountRaw(
    requestParameters: GetTabsCountRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetTabsCount200Response>> {
    const queryParameters: any = {}

    if (requestParameters['search'] != null) {
      queryParameters['search'] = requestParameters['search']
    }

    if (requestParameters['mktu'] != null) {
      queryParameters['mktu'] = requestParameters['mktu']
    }

    if (requestParameters['owners'] != null) {
      queryParameters['owners'] = requestParameters['owners']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/user-registries/tabs-count`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetTabsCount200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Количество пользовательских регистров текущего пользователя по вкладкам фильтра срока действия: ALL — все, VALID — срок больше года, EXPIRES — меньше года либо истёк не более 6 месяцев назад, EXPIRED — восстановление невозможно. dateFilter на подсчёт не влияет. Требуется подтверждённый email.
   * Счётчики вкладок списка регистров
   */
  async getTabsCount(
    requestParameters: GetTabsCountRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetTabsCount200Response> {
    const response = await this.getTabsCountRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Удаление регистра из пользовательских регистров текущего пользователя по пути. Удалять может только пользователь, добавивший регистр (не владелец портфеля info). Требуется подтверждённый email.
   * Удалить регистр из портфеля
   */
  async removeFromRegistriesRaw(
    requestParameters: RemoveFromRegistriesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AppendToRegistries200Response>> {
    if (requestParameters['path'] == null) {
      throw new runtime.RequiredError(
        'path',
        'Required parameter "path" was null or undefined when calling removeFromRegistries().'
      )
    }

    const queryParameters: any = {}

    if (requestParameters['path'] != null) {
      queryParameters['path'] = requestParameters['path']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/user-registries/remove-registry-from-user-registries`,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AppendToRegistries200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Удаление регистра из пользовательских регистров текущего пользователя по пути. Удалять может только пользователь, добавивший регистр (не владелец портфеля info). Требуется подтверждённый email.
   * Удалить регистр из портфеля
   */
  async removeFromRegistries(
    requestParameters: RemoveFromRegistriesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AppendToRegistries200Response> {
    const response = await this.removeFromRegistriesRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }
}
